import { useState, useEffect } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import Logo from '@components/logo'
import { MainMenu, MobileMenu } from '@components/menu'
import Language from '@components/language'
import BurgerButton from '@ui/burger-button'
import OffCanvas, { OffCanvasHeader, OffCanvasBody } from '@ui/off-canvas'
import { useSticky } from '@hooks'
import { usePageContext } from '@context/PageContext'
import SocialIcons from '@ui/social-icons'

import {
  HeaderWrap,
  HeaderTop,
  HeaderBottom,
  HeaderMain,
  HeaderLeft,
  HeaderMiddle,
  HeaderRight,
  HeaderNavigation,
  HeaderElement,
  StyledTopText
} from './style'

import './style.css'

const Header = () => {
  const { sticky, headerRef, fixedRef } = useSticky()
  const [offCanvasOpen, setOffcanvasOpen] = useState(false)

  const { locale } = usePageContext()
  const pageOptions = require('../../../../config/page-options')

  const allHeaderData = useStaticQuery(graphql`
    query {
      allStrapiGeneral {
        nodes {
          ...StrapiHeader
          locale
        }
      }
    }
  `)
  const data =
    allHeaderData.allStrapiGeneral.nodes.find((h) => h.locale === locale)
      ?.header || {}

  const offCanvasHandler = () => {
    if (!offCanvasOpen) {
      document.body.classList.add('no-sidebar')
    } else {
      document.body.classList.remove('no-sidebar')
    }
    setOffcanvasOpen((prevState) => !prevState)
  }

  useEffect(() => {
    return () => document.body.classList.remove('no-sidebar')
  }, [])

  return (
    <>
      <HeaderWrap
        ref={headerRef}
        height={sticky ? `${fixedRef.current?.offsetHeight}px` : 'auto'}
      >
        {data?.slogan && (
          <HeaderTop borderBottom>
            <StyledTopText dangerouslySetInnerHTML={{ __html: data.slogan }} />
          </HeaderTop>
        )}

        <HeaderBottom ref={fixedRef} isSticky={sticky}>
          <HeaderMain>
            <HeaderLeft>
              <Logo darkLogo />
            </HeaderLeft>
            <HeaderMiddle>
              <HeaderNavigation>
                <MainMenu menuData={data.menu} color="dark" />
              </HeaderNavigation>
            </HeaderMiddle>
            <HeaderRight>
              <HeaderElement mr={['10px', null, null, '20px']}>
                {data?.socials && (
                  <SocialIcons
                    socials={data.socials}
                    tooltip_position="bottom"
                    variant="texted"
                    size="large"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  />
                )}
              </HeaderElement>
              <HeaderElement>
                {pageOptions?.locales &&
                  Object.keys(pageOptions.locales).length > 1 && <Language />}
              </HeaderElement>
              <HeaderElement
                pl={['5px', '15px', null, null, null, null]}
                display={['flex', null, null, null, null, 'none']}
              >
                <BurgerButton onClick={offCanvasHandler} aria-label="Menu" />
              </HeaderElement>
            </HeaderRight>
          </HeaderMain>
        </HeaderBottom>
      </HeaderWrap>
      <OffCanvas scrollable isOpen={offCanvasOpen} onClick={offCanvasHandler}>
        <OffCanvasHeader onClick={offCanvasHandler}>
          <Logo darkLogo align={{ default: 'flex-start' }} />
        </OffCanvasHeader>
        <OffCanvasBody>
          <MobileMenu menuData={data.menu} />
        </OffCanvasBody>
      </OffCanvas>
    </>
  )
}

export default Header
